// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AmocrmRouteImport } from './routes/amocrm'
import { Route as Bitrix24RouteImport } from './routes/bitrix24'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as ContextRouteImport } from './routes/context'
import { Route as CorporateRouteImport } from './routes/corporate'
import { Route as EcomRouteImport } from './routes/ecom'
import { Route as ExpertRouteImport } from './routes/expert'
import { Route as GeoRouteImport } from './routes/geo'
import { Route as IpadRouteImport } from './routes/ipad'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as LombardRouteImport } from './routes/lombard'
import { Route as LombardMarketingRouteImport } from './routes/lombard-marketing'
import { Route as PresentationRouteImport } from './routes/presentation'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RetailcrmRouteImport } from './routes/retailcrm'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as SitesRouteImport } from './routes/sites'
import { Route as SvojInternetMagazinDlyaSellerovRouteImport } from './routes/svoj-internet-magazin-dlya-sellerov'
import { Route as UslugiRouteImport } from './routes/uslugi'
import { Route as VacanciesRouteImport } from './routes/vacancies'
import { Route as WebServicesRouteImport } from './routes/web-services'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogAdvertisingRouteImport } from './routes/blog.advertising'
import { Route as BlogContentRouteImport } from './routes/blog.content'
import { Route as BlogCrmRouteImport } from './routes/blog.crm'
import { Route as BlogEcommerceRouteImport } from './routes/blog.ecommerce'
import { Route as BlogEditorialPolicyRouteImport } from './routes/blog.editorial-policy'
import { Route as BlogGeoRouteImport } from './routes/blog.geo'
import { Route as BlogMarketingRouteImport } from './routes/blog.marketing'
import { Route as BlogReputationRouteImport } from './routes/blog.reputation'
import { Route as BlogSeoRouteImport } from './routes/blog.seo'
import { Route as BlogSocialMediaRouteImport } from './routes/blog.social-media'
import { Route as BlogTechnologyRouteImport } from './routes/blog.technology'
import { Route as BlogVideoContentRouteImport } from './routes/blog.video-content'
import { Route as BlogWebDevelopmentRouteImport } from './routes/blog.web-development'
import { Route as CasesIndexRouteImport } from './routes/cases.index'
import { Route as CasesSlugRouteImport } from './routes/cases.$slug'
import { Route as BlogAuthorsHayAgencyRouteImport } from './routes/blog.authors.hay-agency'
import { Route as BlogMarketingCostAccountingRouteImport } from './routes/blog.marketing_.cost-accounting'
import { Route as BlogPagePageRouteImport } from './routes/blog.page.$page'
import { Route as BlogAdvertisingPagePageRouteImport } from './routes/blog.advertising.page.$page'
import { Route as BlogContentPagePageRouteImport } from './routes/blog.content.page.$page'
import { Route as BlogCrmPagePageRouteImport } from './routes/blog.crm.page.$page'
import { Route as BlogEcommercePagePageRouteImport } from './routes/blog.ecommerce.page.$page'
import { Route as BlogGeoPagePageRouteImport } from './routes/blog.geo.page.$page'
import { Route as BlogMarketingPagePageRouteImport } from './routes/blog.marketing.page.$page'
import { Route as BlogReputationPagePageRouteImport } from './routes/blog.reputation.page.$page'
import { Route as BlogSeoPagePageRouteImport } from './routes/blog.seo.page.$page'
import { Route as BlogSocialMediaPagePageRouteImport } from './routes/blog.social-media.page.$page'
import { Route as BlogTechnologyPagePageRouteImport } from './routes/blog.technology.page.$page'
import { Route as BlogVideoContentPagePageRouteImport } from './routes/blog.video-content.page.$page'
import { Route as BlogWebDevelopmentPagePageRouteImport } from './routes/blog.web-development.page.$page'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AmocrmRoute = AmocrmRouteImport.update({
            id: '/amocrm',path: '/amocrm',getParentRoute: () => rootRouteImport
          })
const Bitrix24Route = Bitrix24RouteImport.update({
            id: '/bitrix24',path: '/bitrix24',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const ContextRoute = ContextRouteImport.update({
            id: '/context',path: '/context',getParentRoute: () => rootRouteImport
          })
const CorporateRoute = CorporateRouteImport.update({
            id: '/corporate',path: '/corporate',getParentRoute: () => rootRouteImport
          })
const EcomRoute = EcomRouteImport.update({
            id: '/ecom',path: '/ecom',getParentRoute: () => rootRouteImport
          })
const ExpertRoute = ExpertRouteImport.update({
            id: '/expert',path: '/expert',getParentRoute: () => rootRouteImport
          })
const GeoRoute = GeoRouteImport.update({
            id: '/geo',path: '/geo',getParentRoute: () => rootRouteImport
          })
const IpadRoute = IpadRouteImport.update({
            id: '/ipad',path: '/ipad',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => rootRouteImport
          })
const LombardRoute = LombardRouteImport.update({
            id: '/lombard',path: '/lombard',getParentRoute: () => rootRouteImport
          })
const LombardMarketingRoute = LombardMarketingRouteImport.update({
            id: '/lombard-marketing',path: '/lombard-marketing',getParentRoute: () => rootRouteImport
          })
const PresentationRoute = PresentationRouteImport.update({
            id: '/presentation',path: '/presentation',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RetailcrmRoute = RetailcrmRouteImport.update({
            id: '/retailcrm',path: '/retailcrm',getParentRoute: () => rootRouteImport
          })
const SeoRoute = SeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const SitesRoute = SitesRouteImport.update({
            id: '/sites',path: '/sites',getParentRoute: () => rootRouteImport
          })
const SvojInternetMagazinDlyaSellerovRoute = SvojInternetMagazinDlyaSellerovRouteImport.update({
            id: '/svoj-internet-magazin-dlya-sellerov',path: '/svoj-internet-magazin-dlya-sellerov',getParentRoute: () => rootRouteImport
          })
const UslugiRoute = UslugiRouteImport.update({
            id: '/uslugi',path: '/uslugi',getParentRoute: () => rootRouteImport
          })
const VacanciesRoute = VacanciesRouteImport.update({
            id: '/vacancies',path: '/vacancies',getParentRoute: () => rootRouteImport
          })
const WebServicesRoute = WebServicesRouteImport.update({
            id: '/web-services',path: '/web-services',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogAdvertisingRoute = BlogAdvertisingRouteImport.update({
            id: '/blog/advertising',path: '/blog/advertising',getParentRoute: () => rootRouteImport
          })
const BlogContentRoute = BlogContentRouteImport.update({
            id: '/blog/content',path: '/blog/content',getParentRoute: () => rootRouteImport
          })
const BlogCrmRoute = BlogCrmRouteImport.update({
            id: '/blog/crm',path: '/blog/crm',getParentRoute: () => rootRouteImport
          })
const BlogEcommerceRoute = BlogEcommerceRouteImport.update({
            id: '/blog/ecommerce',path: '/blog/ecommerce',getParentRoute: () => rootRouteImport
          })
const BlogEditorialPolicyRoute = BlogEditorialPolicyRouteImport.update({
            id: '/blog/editorial-policy',path: '/blog/editorial-policy',getParentRoute: () => rootRouteImport
          })
const BlogGeoRoute = BlogGeoRouteImport.update({
            id: '/blog/geo',path: '/blog/geo',getParentRoute: () => rootRouteImport
          })
const BlogMarketingRoute = BlogMarketingRouteImport.update({
            id: '/blog/marketing',path: '/blog/marketing',getParentRoute: () => rootRouteImport
          })
const BlogReputationRoute = BlogReputationRouteImport.update({
            id: '/blog/reputation',path: '/blog/reputation',getParentRoute: () => rootRouteImport
          })
const BlogSeoRoute = BlogSeoRouteImport.update({
            id: '/blog/seo',path: '/blog/seo',getParentRoute: () => rootRouteImport
          })
const BlogSocialMediaRoute = BlogSocialMediaRouteImport.update({
            id: '/blog/social-media',path: '/blog/social-media',getParentRoute: () => rootRouteImport
          })
const BlogTechnologyRoute = BlogTechnologyRouteImport.update({
            id: '/blog/technology',path: '/blog/technology',getParentRoute: () => rootRouteImport
          })
const BlogVideoContentRoute = BlogVideoContentRouteImport.update({
            id: '/blog/video-content',path: '/blog/video-content',getParentRoute: () => rootRouteImport
          })
const BlogWebDevelopmentRoute = BlogWebDevelopmentRouteImport.update({
            id: '/blog/web-development',path: '/blog/web-development',getParentRoute: () => rootRouteImport
          })
const CasesIndexRoute = CasesIndexRouteImport.update({
            id: '/cases/',path: '/cases/',getParentRoute: () => rootRouteImport
          })
const CasesSlugRoute = CasesSlugRouteImport.update({
            id: '/cases/$slug',path: '/cases/$slug',getParentRoute: () => rootRouteImport
          })
const BlogAuthorsHayAgencyRoute = BlogAuthorsHayAgencyRouteImport.update({
            id: '/blog/authors/hay-agency',path: '/blog/authors/hay-agency',getParentRoute: () => rootRouteImport
          })
const BlogMarketingCostAccountingRoute = BlogMarketingCostAccountingRouteImport.update({
            id: '/blog/marketing_/cost-accounting',path: '/blog/marketing/cost-accounting',getParentRoute: () => rootRouteImport
          })
const BlogPagePageRoute = BlogPagePageRouteImport.update({
            id: '/blog/page/$page',path: '/blog/page/$page',getParentRoute: () => rootRouteImport
          })
const BlogAdvertisingPagePageRoute = BlogAdvertisingPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogAdvertisingRoute
          })
const BlogContentPagePageRoute = BlogContentPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogContentRoute
          })
const BlogCrmPagePageRoute = BlogCrmPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogCrmRoute
          })
const BlogEcommercePagePageRoute = BlogEcommercePagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogEcommerceRoute
          })
const BlogGeoPagePageRoute = BlogGeoPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogGeoRoute
          })
const BlogMarketingPagePageRoute = BlogMarketingPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogMarketingRoute
          })
const BlogReputationPagePageRoute = BlogReputationPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogReputationRoute
          })
const BlogSeoPagePageRoute = BlogSeoPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogSeoRoute
          })
const BlogSocialMediaPagePageRoute = BlogSocialMediaPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogSocialMediaRoute
          })
const BlogTechnologyPagePageRoute = BlogTechnologyPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogTechnologyRoute
          })
const BlogVideoContentPagePageRoute = BlogVideoContentPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogVideoContentRoute
          })
const BlogWebDevelopmentPagePageRoute = BlogWebDevelopmentPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => BlogWebDevelopmentRoute
          })





const BlogAdvertisingRouteChildren = {
  BlogAdvertisingPagePageRoute: BlogAdvertisingPagePageRoute
}

const BlogAdvertisingRouteWithChildren = BlogAdvertisingRoute._addFileChildren(BlogAdvertisingRouteChildren)




const BlogContentRouteChildren = {
  BlogContentPagePageRoute: BlogContentPagePageRoute
}

const BlogContentRouteWithChildren = BlogContentRoute._addFileChildren(BlogContentRouteChildren)




const BlogCrmRouteChildren = {
  BlogCrmPagePageRoute: BlogCrmPagePageRoute
}

const BlogCrmRouteWithChildren = BlogCrmRoute._addFileChildren(BlogCrmRouteChildren)




const BlogEcommerceRouteChildren = {
  BlogEcommercePagePageRoute: BlogEcommercePagePageRoute
}

const BlogEcommerceRouteWithChildren = BlogEcommerceRoute._addFileChildren(BlogEcommerceRouteChildren)




const BlogGeoRouteChildren = {
  BlogGeoPagePageRoute: BlogGeoPagePageRoute
}

const BlogGeoRouteWithChildren = BlogGeoRoute._addFileChildren(BlogGeoRouteChildren)




const BlogMarketingRouteChildren = {
  BlogMarketingPagePageRoute: BlogMarketingPagePageRoute
}

const BlogMarketingRouteWithChildren = BlogMarketingRoute._addFileChildren(BlogMarketingRouteChildren)




const BlogReputationRouteChildren = {
  BlogReputationPagePageRoute: BlogReputationPagePageRoute
}

const BlogReputationRouteWithChildren = BlogReputationRoute._addFileChildren(BlogReputationRouteChildren)




const BlogSeoRouteChildren = {
  BlogSeoPagePageRoute: BlogSeoPagePageRoute
}

const BlogSeoRouteWithChildren = BlogSeoRoute._addFileChildren(BlogSeoRouteChildren)




const BlogSocialMediaRouteChildren = {
  BlogSocialMediaPagePageRoute: BlogSocialMediaPagePageRoute
}

const BlogSocialMediaRouteWithChildren = BlogSocialMediaRoute._addFileChildren(BlogSocialMediaRouteChildren)




const BlogTechnologyRouteChildren = {
  BlogTechnologyPagePageRoute: BlogTechnologyPagePageRoute
}

const BlogTechnologyRouteWithChildren = BlogTechnologyRoute._addFileChildren(BlogTechnologyRouteChildren)




const BlogVideoContentRouteChildren = {
  BlogVideoContentPagePageRoute: BlogVideoContentPagePageRoute
}

const BlogVideoContentRouteWithChildren = BlogVideoContentRoute._addFileChildren(BlogVideoContentRouteChildren)




const BlogWebDevelopmentRouteChildren = {
  BlogWebDevelopmentPagePageRoute: BlogWebDevelopmentPagePageRoute
}

const BlogWebDevelopmentRouteWithChildren = BlogWebDevelopmentRoute._addFileChildren(BlogWebDevelopmentRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AmocrmRoute: AmocrmRoute,Bitrix24Route: Bitrix24Route,ContactsRoute: ContactsRoute,ContextRoute: ContextRoute,CorporateRoute: CorporateRoute,EcomRoute: EcomRoute,ExpertRoute: ExpertRoute,GeoRoute: GeoRoute,IpadRoute: IpadRoute,LandingRoute: LandingRoute,LombardRoute: LombardRoute,LombardMarketingRoute: LombardMarketingRoute,PresentationRoute: PresentationRoute,PrivacyRoute: PrivacyRoute,RetailcrmRoute: RetailcrmRoute,SeoRoute: SeoRoute,SitemapRoute: SitemapRoute,SitesRoute: SitesRoute,SvojInternetMagazinDlyaSellerovRoute: SvojInternetMagazinDlyaSellerovRoute,UslugiRoute: UslugiRoute,VacanciesRoute: VacanciesRoute,WebServicesRoute: WebServicesRoute,BlogSlugRoute: BlogSlugRoute,BlogAdvertisingRoute: BlogAdvertisingRouteWithChildren,BlogContentRoute: BlogContentRouteWithChildren,BlogCrmRoute: BlogCrmRouteWithChildren,BlogEcommerceRoute: BlogEcommerceRouteWithChildren,BlogEditorialPolicyRoute: BlogEditorialPolicyRoute,BlogGeoRoute: BlogGeoRouteWithChildren,BlogMarketingRoute: BlogMarketingRouteWithChildren,BlogReputationRoute: BlogReputationRouteWithChildren,BlogSeoRoute: BlogSeoRouteWithChildren,BlogSocialMediaRoute: BlogSocialMediaRouteWithChildren,BlogTechnologyRoute: BlogTechnologyRouteWithChildren,BlogVideoContentRoute: BlogVideoContentRouteWithChildren,BlogWebDevelopmentRoute: BlogWebDevelopmentRouteWithChildren,CasesSlugRoute: CasesSlugRoute,BlogIndexRoute: BlogIndexRoute,CasesIndexRoute: CasesIndexRoute,BlogAuthorsHayAgencyRoute: BlogAuthorsHayAgencyRoute,BlogMarketingCostAccountingRoute: BlogMarketingCostAccountingRoute,BlogPagePageRoute: BlogPagePageRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)